import React, { useMemo } from "react";
import { ShieldAlert } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { EmptyState, Button } from "../ui";
import { useAuth } from "../../hooks/useAuth";
import { getFirstAccessibleAppPath } from "../../lib/defaultHomeRoute";

/**
 * Estado amigável de acesso negado.
 */
const AccessDeniedState = ({
  title = "Acesso negado",
  description = "Você não tem permissão para acessar esta área.",
  showBackButton = true,
}) => {
  const navigate = useNavigate();
  const { granularPermissionsEnabled, hasEffectivePermission, effectivePermissions } = useAuth();
  const homePath = useMemo(
    () => getFirstAccessibleAppPath({ granularPermissionsEnabled, hasEffectivePermission }),
    [granularPermissionsEnabled, effectivePermissions, hasEffectivePermission]
  );

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <EmptyState
        icon={ShieldAlert}
        title={title}
        description={description}
        action={
          showBackButton ? (
            <Button variant="primary" onClick={() => navigate(homePath, { replace: true })}>
              Voltar ao início
            </Button>
          ) : null
        }
      />
    </div>
  );
};

export default AccessDeniedState;

